



















import { VEmojiPicker } from 'v-emoji-picker'
import Vue from 'vue'
//Custom Interface used for the emjoi parameter, reference npm V-Emoji-Picker for more information
interface Emoji {
    data: string
}
export default Vue.extend({
    props: {
        small: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        VEmojiPicker
    },
    data() {
        return {
            open: false
        }
    },
    methods: {
        onEmojiSelected(emoji: Emoji): void {
            this.open = false
            this.$emit('onEmojiSelected', emoji.data)
        }
    }
})
